import React from 'react'
import Svg from '../common/Svg'

export const NotFound = () => {
    return (
        <>
            {/* Red theme */}
            <div className='not-found-wrapper red-bg'>
                <div className="container">
                    <div className="text-wrap text-center">
                        <h1>404</h1>
                        <p>Error: The page you’re looking for can’t be found.</p>
                        <div className="button-wrapper">
                            {/* <button className='btn btn-white btn-icon mx-auto'>
                                Back to Home <Svg name="button-icon" />
                            </button> */}
                        </div>
                    </div>
                </div>
            </div>

            {/* White theme */}
            {/* <div className='not-found-wrapper'>
                <div className="container">
                    <div className="text-wrap text-center">
                        <h1>404</h1>
                        <p>Error: The page you’re looking for can’t be found.</p>
                        <div className="button-wrapper">
                            <button className='btn btn-primary btn-icon mx-auto'>
                                Back to Home <Svg name="button-icon" />
                            </button>
                        </div>
                    </div>
                </div>
            </div> */}
        </>
    )
}
